import React, { ChangeEventHandler } from 'react';

interface Props {
    label: string;
    id: string;
    name: string;
    checked: boolean;
    labelStyle?: React.CSSProperties;
    onChange: ChangeEventHandler<HTMLInputElement>;
}

const AppInputCheckbox = (props: Props) => {
    const { label, id, name, checked, labelStyle, onChange } = props;

    return (
        <>
            <input
                type='checkbox'
                id={id}
                name={name}
                onChange={onChange}
                checked={checked}
                style={{ cursor: 'pointer' }}
            />
            &nbsp;
            <label htmlFor={id} style={labelStyle}>
                {label}
            </label>
        </>
    );
};

export default AppInputCheckbox;
